import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import TemplateHoverAndSelectAllCommand from './templatehoverandselectallcommand';

export default class TemplateHoverAndSelectAllEditing extends Plugin {
  init() {
    this.editor.commands.add( 'toggleTemplateHoverAndSelect', new TemplateHoverAndSelectAllCommand( this.editor ) );
  }
}

